import { render, staticRenderFns } from "./app-footer.vue?vue&type=template&id=31110008&scoped=true&"
import script from "./app-footer.component.ts?vue&type=script&lang=ts&"
export * from "./app-footer.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31110008",
  null
  
)

export default component.exports